import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Input, Row, Text, toFlexItemClassName } from '@dossierhq/design';
import { useCallback } from 'react';
export function NumberFieldEditor({ fieldSpec, value, validationIssues, dragHandle, onChange, }) {
    const isInteger = fieldSpec.integer;
    const handleChange = useCallback((event) => {
        const stringValue = event.target.value.trim();
        if (!stringValue) {
            onChange(null);
        }
        else {
            onChange(isInteger ? parseInt(stringValue) : parseFloat(stringValue));
        }
    }, [onChange, isInteger]);
    return (_jsxs(_Fragment, { children: [_jsxs(Row, { children: [dragHandle, _jsx(Input, { className: toFlexItemClassName({ flexGrow: 1 }), value: value ?? '', type: "number", step: isInteger ? 1 : 'any', onChange: handleChange })] }), validationIssues.map((error, index) => (_jsx(Text, { textStyle: "body2", marginTop: 1, color: "danger", children: error.message }, index)))] }));
}
export function AddNumberListItemButton({ onAddItem, }) {
    return (_jsx(Button, { className: toFlexItemClassName({ alignSelf: 'flex-start' }), onClick: () => onAddItem(null), children: "Add" }));
}
//# sourceMappingURL=NumberFieldEditor.js.map